import { Component, ViewChild, AfterViewInit, OnDestroy, TemplateRef, } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MSSIDCInvoiceDashboard } from '../../../../../shared/models/MSSIDCInvoiceDashboard';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceDetails } from '../../../../../shared/models/IAInvoiceDashboard';

@Component({
  selector: 'app-invoicedashboardmssidc',
  templateUrl: './invoicedashboardmssidc.component.html',
  styleUrl: './invoicedashboardmssidc.component.css'
})
export class InvoicedashboardmssidcComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();
  private loadInvoiceSubscription: Subscription = new Subscription();

  dataSource!: MatTableDataSource<MSSIDCInvoiceDashboard>
  displayedColumns: string[] = ['Sr.No', 'InvoiceId','NameOfOrganisation','EventId','NameofEvent', 'Intervention', 'Component', 'EventStatus','NoOfMSMEAttended', 'InvoiceStatus', 'Action']

  invoiceDataSource!: MatTableDataSource<InvoiceDetails>
  displayedInvoiceColumns: string[] = ['Sr.No', 'eventId', 'invoiceId', 'dateofSubmission', 'dateofActionTaken', 'finalTotal', 'Download', 'invoiceAccepted']


  @ViewChild(MatPaginator) invoicePagination!: MatPaginator;
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  allrecord: any[] = [];

  EventList: any[] = [];

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];

  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  mobile = sessionStorage.getItem('mobile');

  DtoPagination =
    {
      "Mobile": this.mobile,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }

  DtoPaginationInvoice = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "EventId": "",
  }

  constructor(
    private apiService: ApiService, private router: Router, public dialog: MatDialog,
    private toastrService: ToastrService, public commonService: CommonService) { }

  form = new FormGroup({
    searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])
  })

  async ngOnInit(): Promise<void> {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
  }

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTFORMSSIDC, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  //loadData() {
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.commonService.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTFORMSSIDC, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp.status) {
  //          this.length = resp['totalRecords'];
  //        }
  //        return resp.data;
  //      })
  //    ).subscribe(data => {
  //      this.dataSource = data;
  //      this.adjustPaginator();
  //    });
  //}

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  ViewInvoiceDetails(eventId: string) {
    sessionStorage.setItem("EventId", eventId);
    this.router.navigate(['/viewinvoicedetails']);
  }

  UpdatePaymentDetails(eventId: string) {
    sessionStorage.setItem("EventId", eventId);
    this.router.navigate(['/updatepaymentdetails']);
  }
  
  OpenInvoice(InvoiceFileName: string, InvoiceFilePath: string) {
    const fullPath = InvoiceFilePath + '/' + InvoiceFileName;
    window.open(fullPath, '_blank');
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadData();
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadData();
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.loadData();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.form.get('searchControl');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;
      this.loadData();
    }
  }

  //eexportToExcel(): void {
  //  const fileName = 'Event_List.xlsx';

  //  const DtoPagination = {
  //    PageNumber: 1,
  //    PageSize: 9999999,
  //    SortColumn: "",
  //    SortDirection: "",
  //    SearchTerm: "",
  //    SearchCol: this.commonService.searchText,
  //  };

  //  this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTFORMSSIDC, DtoPagination).subscribe(
  //    result => {
  //      if (result.status) {
  //        this.allrecord = result.data;
  //      }
  //      if (!this.allrecord || this.allrecord.length === 0) {
  //        this.toastrService.error('No data available to export.');
  //        return;
  //      }
  //    });

  //  //if (!this.allrecord || this.allrecord.length === 0) {
  //  //  this.toastrService.error('No data available to export.');
  //  //  return;
  //  //}

  //  const excelData = this.allrecord.map((item, index) => ({
  //    'Sr. No': index + 1,
  //    'Invoice Number':item.invoiceID,
  //    'Event Id': item.eventId,
  //    'Name of Event': item.eventName,
  //    'Intervention': item.interventionName,
  //    'Component': item.interestName,
  //    'Event Status': item.eventStatus,
  //    'Count of MSME attended the event (Verified/Unverified)': item.noOfMSMEAttended,
  //    'Invoice Status': item.invoiceStatus,
  //  }));

  //  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

  //  const columnWidths = [
  //    { wch: 10 }, // Sr. No
  //    { wch: 30 }, // Name of Event
  //    { wch: 20 }, // Intervention
  //    { wch: 25 }, // Component
  //    { wch: 15 }, // Event Status
  //    { wch: 50 }, // Count of MSME attended the event (Verified/Unverified)
  //    { wch: 20 }, // Invoice Status
  //  ];
  //  worksheet['!cols'] = columnWidths;

  //  const workbook: XLSX.WorkBook = {
  //    Sheets: { 'Event List': worksheet },
  //    SheetNames: ['Event List'],
  //  };

  //  const excelBuffer: any = XLSX.write(workbook, {
  //    bookType: 'xlsx',
  //    type: 'array',
  //  });

  //  const data: Blob = new Blob([excelBuffer], {
  //    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  //  });

  //  saveAs(data, fileName);
  //  this.toastrService.success('Excel exported successfully!');
  //}

  //exportToExcel(): void {
  //  const fileName = 'Invoice_Details.xlsx';

  //  const DtoPagination = {
  //    PageNumber: 1,
  //    PageSize: 9999999, // Fetch all records for export
  //    SortColumn: "",
  //    SortDirection: "",
  //    SearchTerm: "",
  //    SearchCol: this.commonService.searchText, // Assuming commonService is accessible
  //  };

  //  this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTFORMSSIDC, DtoPagination).subscribe(
  //    result => {
  //      if (result.status && result.data) {
  //        this.allrecord = result.data; // Data is successfully fetched and assigned

  //        if (!this.allrecord || this.allrecord.length === 0) {
  //          this.toastrService.error('No data available to export.');
  //          return;
  //        }

  //        // ALL THE EXCEL GENERATION AND EXPORT LOGIC GOES HERE
  //        // This ensures that 'this.allrecord' has been populated before use.
  //        const excelData = this.allrecord.map((item, index) => ({
  //          'Sr. No': index + 1,
  //          'Invoice Number': item.invoiceID,
  //          'Event Id': item.eventId,
  //          'Name of Event': item.eventName,
  //          'Intervention': item.interventionName,
  //          'Component': item.interestName,
  //          'Event Status': item.eventStatus,
  //          'Count of MSME attended the event (Verified/Unverified)': item.noOfMSMEAttended,
  //          'Invoice Status': item.invoiceStatus,
  //        }));

  //        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

  //        const columnWidths = [
  //          { wch: 10 }, // Sr. No
  //          { wch: 15 }, // Invoice Number (Adjust width as needed)
  //          { wch: 15 }, // Event Id (Adjust width as needed)
  //          { wch: 30 }, // Name of Event
  //          { wch: 20 }, // Intervention
  //          { wch: 25 }, // Component
  //          { wch: 15 }, // Event Status
  //          { wch: 50 }, // Count of MSME attended the event (Verified/Unverified)
  //          { wch: 20 }, // Invoice Status
  //        ];
  //        worksheet['!cols'] = columnWidths;

  //        const workbook: XLSX.WorkBook = {
  //          Sheets: { 'Event List': worksheet },
  //          SheetNames: ['Invoice Details'],
  //        };

  //        const excelBuffer: any = XLSX.write(workbook, {
  //          bookType: 'xlsx',
  //          type: 'array',
  //        });

  //        const data: Blob = new Blob([excelBuffer], {
  //          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  //        });

  //        saveAs(data, fileName);
  //        this.toastrService.success('Excel exported successfully!');
  //      } else {
  //        // Handle cases where result.status is false or result.data is null/undefined
  //        this.toastrService.error('Failed to retrieve data for export. Please try again.');
  //      }
  //    },
  //    error => {
  //      // Handle network errors or other subscription errors
  //      this.toastrService.error('An error occurred during data retrieval for export.');
  //      console.error('API Error:', error);
  //    }
  //  );
  //}
  exportToExcel(): void {
    const fileName = 'Invoice_Details.xlsx';

    const pagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    // Pass query params CORRECTLY
    this.apiService.getRequest(
      API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTFORMSSIDC,
      pagination
    ).subscribe({
      next: (result) => {
        if (!result?.status || !result.data) {
          this.toastrService.error('No data available to export.');
          return;
        }

        this.allrecord = result.data;

        if (this.allrecord.length === 0) {
          this.toastrService.error('No data available to export.');
          return;
        }

        const excelData = this.allrecord.map((item, index) => ({
          'Sr. No': index + 1,
          'Invoice Number': item.invoiceID,
          'Event Id': item.eventId,
          'Name of Event': item.eventName,
          'Intervention': item.interventionName,
          'Component': item.interestName,
          'Event Status': item.eventStatus,
          'Count of MSME attended the event (Verified/Unverified)': item.noOfMSMEAttended,
          'Invoice Status': item.invoiceStatus,
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        worksheet['!cols'] = [
          { wch: 10 },
          { wch: 20 },
          { wch: 20 },
          { wch: 40 },
          { wch: 20 },
          { wch: 25 },
          { wch: 20 },
          { wch: 50 },
          { wch: 20 },
        ];

        const workbook = {
          Sheets: { 'Invoice Details': worksheet },
          SheetNames: ['Invoice Details'],
        };

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        saveAs(
          new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          fileName
        );

        this.toastrService.success('Excel exported successfully!');
      },
      error: (err) => {
        this.toastrService.error('Failed to fetch data for export.');
        console.error(err);
      }
    });
  }
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  openFilePreviewDialog(fileName: string, filePath: string): void {

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  //#region My Invoice Section
  invoicePageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  invoiceLength: number = 0;
  invoicePageSize: number = 10;
  invoiceDisplayedData: any[] = [];
  invoiceHidePageSize = false;
  invoiceShowPageSizeOptions = true;
  invoiceShowFirstLastButtons = true;
  invoiceDisabled = false;
  invoicePageIndex = 0;
  invoicePageEvent!: PageEvent;


  onPageInvoiceChange(e: PageEvent) {
    this.invoicePageEvent = e;
    this.invoiceLength = e.length;
    this.invoicePageSize = e.pageSize;
    this.invoicePageIndex = e.pageIndex;

    this.DtoPaginationInvoice.PageNumber = e.pageIndex + 1;
    this.DtoPaginationInvoice.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETENROLLEDMSMELISTFORMSSIDC, this.DtoPaginationInvoice)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
          this.displayedInvoiceColumns = resp.data;
          this.invoiceLength = resp.totalRecords;
        }
      });
  }

  viewInvoiceDetails(templateRef: TemplateRef<any>, eventId: string): void {
    if (!this.invoicePagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    if (this.loadInvoiceSubscription) {
      this.loadInvoiceSubscription.unsubscribe();
    }

    // Scroll to the top immediately when function is triggered
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Reset subscription with a new request
    this.loadInvoiceSubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.invoicePagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.invoicePagination.pageIndex = 0;
          this.DtoPaginationInvoice.SortColumn = this.sort?.active;
          this.DtoPaginationInvoice.SortDirection = this.sort?.direction;
          this.DtoPaginationInvoice.SearchCol = this.commonService.searchText;
          this.DtoPaginationInvoice.EventId = eventId;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICEDOCUMENTDETAILS, this.DtoPaginationInvoice)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            console.table(resp.data)
            this.invoiceLength = resp.totalRecords;
            return resp?.data || {};
          }
          return null;
        })
      )
      .subscribe(data => {
        if (data) {
          this.invoiceDataSource = data;
          this.adjustInvoicePaginator();
          // Scroll to the top again to ensure proper placement after data load
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.notCallingPopup();
        }


        // Open dialog after grid data is updated
        const dialogRef2 = this.dialog.open(templateRef, {
          width: '1100px', // Customize the width of the dialog
          height: '60vh', // Optionally customize the height
        });

        dialogRef2.afterClosed().subscribe(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
    //this.router.navigate(['/reports/viewevent', uniqueEventId]);
    //this.closeDialog();
  }

  adjustInvoicePaginator() {
    const totalPages = Math.ceil(this.invoiceLength / this.invoicePageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.invoicePageIndex >= totalPages) {
      this.invoicePageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationInvoice.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.invoicePagination.pageIndex = this.invoicePageIndex;
  }

  notCallingPopup() {
    this.loadDataSubscription.unsubscribe();
    this.loadInvoiceSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    //this.LoadGradingRecord();
  }

  onClosePopup() {
    this.DtoPaginationInvoice.PageNumber = 1;
    this.invoicePageIndex = 0;
    this.invoicePagination.pageIndex = 0;
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  openFilePreviewInvoiceDialog(templateRef: TemplateRef<any>, filePath: string, fileName: string): void {
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(templateRef, {
          width: '80%',
          height: '80%',
          data: { fileUrl, fileName }
        });
      },
      error: (err) => {
        console.error('File preview failed:', err);
      }
    });
  }
  //#endregion
}
